var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 135,
    viewBox: "0 0 139 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5444_36164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4546 72.2818H0V68.7232C0.302172 65.6151 0.777407 62.5264 1.42343 59.4712L7.96215 60.8501C7.56182 62.6738 7.29492 64.3196 7.117 65.6096H12.2323L12.4546 72.2818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.824 72.2818H93.8108V65.832H110.002L109.824 72.2818ZM77.3972 72.2818H61.1617V65.832H77.3972V72.2818ZM44.9261 72.2818H28.6904V65.832H44.8816L44.9261 72.2818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.292 72.2817H125.882V65.8319H131.131C131.131 64.4975 130.73 62.8517 130.374 60.9835L136.913 59.738C137.515 62.8075 137.916 65.9129 138.114 69.0346L138.292 72.2817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.015 44.9703C124.035 39.8901 121.452 35.0663 118.32 30.6029L123.791 26.7776C127.213 31.6714 130.035 36.958 132.198 42.5239L126.015 44.9703ZM12.9889 44.9703L6.85059 42.4349C9.06021 36.9046 11.8799 31.6381 15.2574 26.7331L20.7287 30.5585C17.6378 35.0386 15.0426 39.841 12.9889 44.8814V44.9703ZM107.155 18.86C102.936 15.54 98.2431 12.8712 93.2327 10.9424L95.5902 4.71504C101.243 6.87191 106.536 9.87123 111.292 13.6112L107.155 18.86ZM31.5375 18.6376L27.3563 13.4333C32.0889 9.68334 37.3696 6.68292 43.0136 4.53708L45.4156 10.7644C40.4111 12.6572 35.7298 15.3131 31.5375 18.6376ZM77.4864 7.16144C72.0442 6.60501 66.5596 6.60501 61.1174 7.16144L60.4947 0.533809C66.4102 -0.0698633 72.3717 -0.0698633 78.2872 0.533809L77.4864 7.16144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.274 120.544L112.76 114.894C115.161 113.424 117.478 111.82 119.699 110.091L123.924 115.25C121.498 117.187 118.942 118.956 116.274 120.544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4794 135C64.0247 134.863 58.5989 134.163 53.2884 132.909L54.7562 126.415C59.5913 127.523 64.5217 128.164 69.4794 128.328H71.9259L72.1929 135H69.4794ZM86.1153 133.087L84.6475 126.593C90.3214 125.32 95.8507 123.472 101.15 121.077L103.908 127.127C98.2009 129.728 92.2376 131.726 86.1153 133.087ZM39.6327 128.639C33.7392 126.268 28.2009 123.094 23.1747 119.209L27.3114 113.96C31.8464 117.466 36.8465 120.326 42.1682 122.456L39.6327 128.639ZM12.9441 109.023C9.09218 103.918 6.08826 98.2257 4.04785 92.1648L10.3641 89.9851C12.1527 95.3694 14.7961 100.431 18.1928 104.975L12.9441 109.023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.889845 78.2421C0.533996 75.2619 0.311618 72.1481 0.222656 68.99H6.89481C6.94087 71.8315 7.14885 74.6681 7.51761 77.4859L0.889845 78.2421Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5444_36164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.47,
    height: 135,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerE);
export default __webpack_public_path__ + "static/media/LOWER_E.03d47d617935181b68b58154e7d36249.svg";
export { ForwardRef as ReactComponent };